import { render } from "./Client.vue?vue&type=template&id=7d8d3df8&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=7d8d3df8&lang=scss&scoped=true"

import exportComponent from "/Users/hxp/Workspace/bintangmas-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8d3df8"]])

export default __exports__